import { IProductCard } from '@src/components/product-card/product-card.types'
import { TrackConfig } from '@src/quince-components/src/hocs/withTracking'

import { ProductLite } from '../../domains/Product'
import Product from '../../domains/Product/Product'
import { ProductVariantOption } from '../../domains/ProductVariant'
import PubSub from '../PubSub'

export interface ProductBuyNowState {
  showPopUp: boolean
  product?: Product | ProductLite | null
  productCard?: IProductCard
  selectedOptions: ProductVariantOption[]
  trackerKey: string
  searchQuery?: string
  position?: number
  trackerData?: TrackConfig
}

interface SetProductBuyNowPayload {
  product?: Product | ProductLite
  productCard?: IProductCard
  selectedOptions: ProductVariantOption[]
  trackerKey?: string
  searchQuery?: string
  position?: number
  productClickTrackConfig?: TrackConfig
}

class ProductBuyNowStateManager extends PubSub {
  private state: ProductBuyNowState

  constructor() {
    super()
    this.state = {
      showPopUp: false,
      product: null,
      productCard: undefined,
      selectedOptions: [],
      trackerKey: '',
      searchQuery: undefined,
      position: undefined,
    }
  }

  showBuyNowPopUp = (payload: SetProductBuyNowPayload) => {
    this.state.showPopUp = true
    this.state.product = payload.product
    this.state.productCard = payload.productCard
    this.state.selectedOptions = payload.selectedOptions
    this.state.trackerKey = payload.trackerKey ? payload.trackerKey : 'quick_shop'
    this.state.searchQuery = payload.searchQuery
    this.state.position = payload.position
    this.state.trackerData = payload.productClickTrackConfig
    this.publish()
  }

  hideBuyNowPopUp = () => {
    this.state.showPopUp = false
    this.state.product = null
    this.state.productCard = undefined
    this.state.selectedOptions = []
    this.publish()
  }

  getProductBuyNowState = () => {
    return this.state
  }
}

const productBuyNowStateManager: ProductBuyNowStateManager =
  ProductBuyNowStateManager.getInstance('productBuyNowStateManager')

export default productBuyNowStateManager
